export default "__VITE_ASSET__EacE6_JP__"